import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderSummaryTitleStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    ordeOrderCustomerPo?: TypographyProps;
}

export const orderSummaryTitleStyles: OrderSummaryTitleStyles = {
    wrapper: {
        css: css`
            padding-bottom: ${themeFontSizes.size15};
        `,
    },
    titleText: {
        variant: "h5",
        as: "h2",
        css: css`
            @media print {
                font-size: ${themeFontSizes.size18};
            }
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size18};
            font-weight: ${themeFontWeights.fontWeightForBold};
            letter-spacing: 0;
            line-height: ${themeFontSizes.size23};
            margin-bottom: 0;
        `,
    },
};

const styles = orderSummaryTitleStyles;

const OrderSummaryTitle: FC = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="OrderSummaryTitle">
                {translate("Order Summary")}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderSummaryTitle,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
